jQuery(function () {
    var popupWrapper = $('.onboarding-test-account__popup-wrapper');
    $('.ts-select-house').on('click', function () {
        $(this).children().toggleClass('selected');
    });
    $('.ts-onboarding-test-account-clean-info-btn').on('click', function () {
        popupWrapper.removeClass('hidden');
    });
    $('.ts-onboarding-test-account-popup-cancel-btn').on('click', function () {
        popupWrapper.addClass('hidden');
    });
    $('.ts-onboarding-test-account-save-info-btn').on('click', function () {
        var houseIds = $('.onboarding-test-account__house.selected').map(function () { return $(this).data('houseid'); }).get();
        var request = {
            url: 'skapa-hus/migratehouses',
            data: { houseIds: houseIds }
        };
        $.post(request).done(function (response) {
            if (response && response.success) {
                window.location.href = '/';
            }
            else {
                var errorbox = $('.onboarding-test-account__errorbox');
                errorbox.removeClass('hidden');
                errorbox.text(response.message);
            }
        });
    });
    $('.ts-onboarding-test-account-popup-confirm-btn').on('click', function () {
        var request = {
            url: 'skapa-hus/deletetestaccount'
        };
        $.post(request).done(function (response) {
            if (response && response.success) {
                window.location.href = '/';
            }
            else {
                var errorbox = $('.onboarding-test-account__errorbox');
                errorbox.removeClass('hidden');
                errorbox.text(response.message);
            }
        });
    });
});
